import { Box } from '@material-ui/core';
import React from 'react';
import useOrgUserDetails from 'src/hooks/useOrgUserDetails';
import { OrgUserStatus } from 'src/types';
import ActivateUser from './ActivateUser';
import DisableUser from './DisableUser';
import RemoveUser from './RemoveUser';
import ResetUserPassword from './ResetUserPassword';

const OrgUserActions: React.FC = () => {
  const { userDetails } = useOrgUserDetails();

  return (
    <Box display="flex" flexDirection={['column', 'row']}>
      {userDetails.status !== OrgUserStatus.Invited && (
        <Box mr={2} mb={[2, 0]}>
          <ResetUserPassword />
        </Box>
      )}
      <Box mr={2} mb={[2, 0]}>
        {userDetails.status === OrgUserStatus.Inactive ? (
          <ActivateUser />
        ) : (
          <DisableUser />
        )}
      </Box>
      <Box mr={2} mb={[2, 0]}>
        <RemoveUser />
      </Box>
    </Box>
  );
};
export default OrgUserActions;
